import { type StateCreator, create } from 'zustand';
import { UserSliceType, SparkUserStateType } from 'types/store/userStore';
import type { ApplicationUser } from 'types/ApplicationUser';

const NULL_INITIAL_STORE_VALUES: SparkUserStateType = {
  applicationUser: undefined,
  currentUserID: undefined,
};

const sparkUserSlice: StateCreator<UserSliceType> = (set, get, store) => ({
  ...NULL_INITIAL_STORE_VALUES,

  setApplicationUser: (applicationUser: ApplicationUser) =>
    set((state) => ({
      ...state,
      applicationUser: applicationUser,
      currentUserID: applicationUser.id,
    })),

  resetUserStore: () =>
    set((state) => ({ ...state, ...NULL_INITIAL_STORE_VALUES })),
});

export const useUserStore = create<UserSliceType>((set, get, store) => ({
  ...sparkUserSlice(set, get, store),
}));
